export interface LatLng {
    lat: number,
    lng: number
}

export const CHICAGO: LatLng = {lat: 41.939292, lng: -87.650396}
export const DEFAULT_ZOOM = 18
